'use strict';

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var pMapSeries = require('p-map-series');

var AccessController = require('./access-controller-interface');

var ensureAddress = require('./utils/ensure-ac-address');

var type = 'orbitdb';

var OrbitDBAccessController = /*#__PURE__*/function (_AccessController) {
  _inherits(OrbitDBAccessController, _AccessController);

  var _super = _createSuper(OrbitDBAccessController);

  function OrbitDBAccessController(orbitdb, options) {
    var _this;

    _classCallCheck(this, OrbitDBAccessController);

    _this = _super.call(this);
    _this._orbitdb = orbitdb;
    _this._db = null;
    _this._options = options || {};
    return _this;
  } // Returns the type of the access controller


  _createClass(OrbitDBAccessController, [{
    key: "address",
    get: // Returns the address of the OrbitDB used as the AC
    function get() {
      return this._db.address;
    } // Return true if entry is allowed to be added to the database

  }, {
    key: "canAppend",
    value: function () {
      var _canAppend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(entry, identityProvider) {
        var access, verifiedIdentity;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Write keys and admins keys are allowed
                access = new Set([].concat(_toConsumableArray(this.get('write')), _toConsumableArray(this.get('admin')))); // If the ACL contains the writer's public key or it contains '*'

                if (!(access.has(entry.identity.id) || access.has('*'))) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return identityProvider.verifyIdentity(entry.identity);

              case 4:
                verifiedIdentity = _context.sent;
                return _context.abrupt("return", verifiedIdentity);

              case 6:
                return _context.abrupt("return", false);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function canAppend(_x, _x2) {
        return _canAppend.apply(this, arguments);
      }

      return canAppend;
    }()
  }, {
    key: "capabilities",
    get: function get() {
      if (this._db) {
        var capabilities = this._db.index;

        var toSet = function toSet(e) {
          var key = e[0];
          capabilities[key] = new Set([].concat(_toConsumableArray(capabilities[key] || []), _toConsumableArray(e[1])));
        }; // Merge with the access controller of the database
        // and make sure all values are Sets


        Object.entries(_objectSpread(_objectSpread({}, capabilities), {
          admin: new Set([].concat(_toConsumableArray(capabilities.admin || []), _toConsumableArray(this._db.access.write)))
        })).forEach(toSet);
        return capabilities;
      }

      return {};
    }
  }, {
    key: "get",
    value: function get(capability) {
      return this.capabilities[capability] || new Set([]);
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._db.close();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._db) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this._db.close();

              case 3:
                _context3.next = 5;
                return this._orbitdb.keyvalue(ensureAddress(address), {
                  // use ipfs controller as a immutable "root controller"
                  accessController: {
                    type: 'ipfs',
                    write: this._options.admin || [this._orbitdb.identity.id]
                  },
                  sync: true
                });

              case 5:
                this._db = _context3.sent;

                this._db.events.on('ready', this._onUpdate.bind(this));

                this._db.events.on('write', this._onUpdate.bind(this));

                this._db.events.on('replicated', this._onUpdate.bind(this));

                _context3.next = 11;
                return this._db.load();

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function load(_x3) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", {
                  address: this._db.address.toString()
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "grant",
    value: function () {
      var _grant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(capability, key) {
        var capabilities;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // Merge current keys with the new key
                capabilities = new Set([].concat(_toConsumableArray(this._db.get(capability) || []), [key]));
                _context5.next = 3;
                return this._db.put(capability, Array.from(capabilities.values()));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function grant(_x4, _x5) {
        return _grant.apply(this, arguments);
      }

      return grant;
    }()
  }, {
    key: "revoke",
    value: function () {
      var _revoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(capability, key) {
        var capabilities;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                capabilities = new Set(this._db.get(capability) || []);
                capabilities.delete(key);

                if (!(capabilities.size > 0)) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 5;
                return this._db.put(capability, Array.from(capabilities.values()));

              case 5:
                _context6.next = 9;
                break;

              case 7:
                _context6.next = 9;
                return this._db.del(capability);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function revoke(_x6, _x7) {
        return _revoke.apply(this, arguments);
      }

      return revoke;
    }()
    /* Private methods */

  }, {
    key: "_onUpdate",
    value: function _onUpdate() {
      this.emit('updated');
    }
    /* Factory */

  }], [{
    key: "type",
    get: function get() {
      return type;
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(orbitdb) {
        var options,
            ac,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                ac = new OrbitDBAccessController(orbitdb, options);
                _context8.next = 4;
                return ac.load(options.address || options.name || 'default-access-controller');

              case 4:
                if (!(options.write && !options.address)) {
                  _context8.next = 7;
                  break;
                }

                _context8.next = 7;
                return pMapSeries(options.write, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            return _context7.abrupt("return", ac.grant('write', e));

                          case 1:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x9) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 7:
                return _context8.abrupt("return", ac);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function create(_x8) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return OrbitDBAccessController;
}(AccessController);

module.exports = OrbitDBAccessController;